
import { toString, Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { RequestedValue$1, RequestedValue$1_$reflection, DocumentId_$reflection, DocumentDetail_$reflection, DocumentId__get_unwrap, FormState__getValidation, FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, FormState_$reflection, SetId__get_unwrap, ClientApiResponse$1_$reflection, PostResponse$1_$reflection, EmptyResponse_$reflection, SetId_$reflection, ConsumableId_$reflection, ToolId_$reflection } from "../../Shared/Shared.js";
import { list_type, record_type, bool_type, lambda_type, unit_type, option_type, class_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_ofEffect, Cmd_batch, Cmd_none, Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { ensureRequestBodySize } from "../../ErrorHandling.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { empty as empty_1, filter, tryFind, tryHead, item as item_1, length, toArray, map, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { nativeType, useDrop } from "../../Bindings/Fable.ReactDnD.js";
import { item, equalsWith } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { createObj, defaultOf, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { toArray as toArray_1, singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { InformationAlert, ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";
import Upload_File from "../../../public/assets/icons/Upload_File.svg";
import { TextValue } from "../../Components/Text.js";
import { Input } from "../../Components/Input.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ConfirmationDialog, Dialog } from "../../Components/Dialog.js";
import { defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Auto_generateBoxedEncoder_437914C6, toString as toString_1 } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { UpdateDocumentDto, UpdateDocumentDto_$reflection } from "../../Shared/Tool.js";
import { unwrapConsumableId, unwrapDocumentId, unwrapToolId } from "../../Shared/Helper.js";
import { ImageViewer } from "../../Components/ImageViewer.js";
import { usePermissions } from "../../UserPermissions.js";
import { Permission, Permissions_has } from "../../Shared/Roles.js";
import { TableControl$1, Table } from "../Table/Table.js";
import Convert_PDF_2 from "../../../public/assets/icons/Convert_PDF_2.svg";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import New_File from "../../../public/assets/icons/New_File.svg";
import Download_File from "../../../public/assets/icons/Download_File.svg";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { Cmd_downloadFileCmd } from "../../Requests/Consumable.js";
import { Cmd_downloadFileCmd as Cmd_downloadFileCmd_1 } from "../../Requests/Tool.js";
import { downloadFileCmd } from "../../Requests/Set.js";
import { onBlobReceived, getBlob } from "../../Communication.js";
import { Cmd_OfPromise_either as Cmd_OfPromise_either_1 } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { unwrapToolId as unwrapToolId_1, unwrapConsumableId as unwrapConsumableId_1 } from "../../Shared/Helper.js";
import { SetId__get_unwrap as SetId__get_unwrap_1 } from "../../Shared/Shared.js";
import { ChangelogTable } from "../Tables/ChangelogTable.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class FileDialog_LinkedDocumentToolType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Consumable", "ToolWithQuantity", "Set"];
    }
}

export function FileDialog_LinkedDocumentToolType_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.FileDialog.LinkedDocumentToolType", [], FileDialog_LinkedDocumentToolType, () => [[["Item", ToolId_$reflection()]], [["Item", ConsumableId_$reflection()]], [["Item", ToolId_$reflection()]], [["Item", SetId_$reflection()]]]);
}

export class FileDialog_LinkedEntityId extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ReminderId", "InspectionResultId"];
    }
}

export function FileDialog_LinkedEntityId_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.FileDialog.LinkedEntityId", [], FileDialog_LinkedEntityId, () => [[["Item", string_type]], [["Item", string_type]]]);
}

class FileDialog_Upload_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectFile", "SetIsVisibleForUserRole", "SetName", "SetDescription", "Upload", "InventoryUploadCompleted", "UploadCompletedV2", "FetchError"];
    }
}

function FileDialog_Upload_Msg_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Upload.Msg", [], FileDialog_Upload_Msg, () => [[["Item", class_type("Browser.Types.File", undefined)]], [], [["Item", string_type]], [["Item", string_type]], [], [["Item", ClientApiResponse$1_$reflection(PostResponse$1_$reflection(EmptyResponse_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function FileDialog_Upload_saveToolDocumentCmd(toolId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/tools/", toolId.fields[0], ..."/files"), formData], (Item) => (new FileDialog_Upload_Msg(5, [Item])), (Item_1) => (new FileDialog_Upload_Msg(7, [Item_1])));
}

function FileDialog_Upload_saveConsumableDocumentCmd(consumableId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/consumables/", consumableId.fields[0], ..."/files"), formData], (Item) => (new FileDialog_Upload_Msg(5, [Item])), (Item_1) => (new FileDialog_Upload_Msg(7, [Item_1])));
}

function FileDialog_Upload_saveSetDocumentCmd(setId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), PostResponse$1_$reflection(EmptyResponse_$reflection())));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/sets/", SetId__get_unwrap(setId), ..."/files"), formData], (Item) => (new FileDialog_Upload_Msg(5, [Item])), (Item_1) => (new FileDialog_Upload_Msg(7, [Item_1])));
}

function FileDialog_Upload_saveReceiverDocumentCmd(receiverId, formData) {
    return Cmd_OfPromise_either((tupledArg) => {
        const formData_2 = tupledArg[1];
        return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_3;
            ensureRequestBodySize(formData_2);
            return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [formData_2])]), undefined, (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
            }, refreshOn)))(true);
        }));
    }, [concat("/api/receivers/", receiverId, ..."/files"), formData], (Item) => (new FileDialog_Upload_Msg(6, [Item])), (Item_1) => (new FileDialog_Upload_Msg(7, [Item_1])));
}

class FileDialog_Upload_State extends Record {
    constructor(SelectedFile, UploadType, SuccessCallback, OnClose, Name, Description, IsVisibleForUserRole, FormState, LinkedEntityId) {
        super();
        this.SelectedFile = SelectedFile;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Name = Name;
        this.Description = Description;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
        this.FormState = FormState;
        this.LinkedEntityId = LinkedEntityId;
    }
}

function FileDialog_Upload_State_$reflection() {
    return record_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Upload.State", [], FileDialog_Upload_State, () => [["SelectedFile", option_type(class_type("Browser.Types.File", undefined))], ["UploadType", FileDialog_LinkedDocumentToolType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Name", string_type], ["Description", string_type], ["IsVisibleForUserRole", bool_type], ["FormState", FormState_$reflection()], ["LinkedEntityId", FileDialog_LinkedEntityId_$reflection()]]);
}

function FileDialog_Upload_init(uploadType, linkedEntityId, successCallback, onClose) {
    return [new FileDialog_Upload_State(undefined, uploadType, successCallback, onClose, "", "", false, FormState_get_empty(), linkedEntityId), Cmd_none()];
}

function FileDialog_Upload_update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, msg.fields[0], state.Description, state.IsVisibleForUserRole, state.FormState, state.LinkedEntityId), Cmd_none()];
        case 3:
            return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, msg.fields[0], state.IsVisibleForUserRole, state.FormState, state.LinkedEntityId), Cmd_none()];
        case 1:
            return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, !state.IsVisibleForUserRole, state.FormState, state.LinkedEntityId), Cmd_none()];
        case 4: {
            const matchValue = state.SelectedFile;
            if (matchValue == null) {
                return [state, Cmd_none()];
            }
            else {
                const file_1 = matchValue;
                const formData = new FormData();
                formData.append(file_1.name, file_1);
                formData.append("Name", state.Name);
                formData.append("Description", state.Description);
                formData.append("IsVisibleForUserRole", toString(state.IsVisibleForUserRole));
                const matchValue_1 = state.LinkedEntityId;
                if (matchValue_1.tag === 1) {
                    formData.append("InspectionResultId", matchValue_1.fields[0]);
                }
                else {
                    formData.append("ReminderId", matchValue_1.fields[0]);
                }
                let cmd;
                const matchValue_2 = state.UploadType;
                cmd = ((matchValue_2.tag === 1) ? FileDialog_Upload_saveConsumableDocumentCmd(matchValue_2.fields[0], formData) : ((matchValue_2.tag === 2) ? FileDialog_Upload_saveToolDocumentCmd(matchValue_2.fields[0], formData) : ((matchValue_2.tag === 3) ? FileDialog_Upload_saveSetDocumentCmd(matchValue_2.fields[0], formData) : FileDialog_Upload_saveToolDocumentCmd(matchValue_2.fields[0], formData))));
                return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState__startLoading(state.FormState), state.LinkedEntityId), cmd];
            }
        }
        case 5:
            if (msg.fields[0].tag === 1) {
                return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.LinkedEntityId), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState_get_empty(), state.LinkedEntityId), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_upload_succes")]))];
            }
        case 6:
            if (msg.fields[0].tag === 1) {
                return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0]), state.LinkedEntityId), Cmd_errorToast("general.a_error_occured")];
            }
            else {
                return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState_get_empty(), state.LinkedEntityId), Cmd_batch(ofArray([Cmd_ofEffect((_arg_2) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_3) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_upload_succes")]))];
            }
        case 7:
            return [new FileDialog_Upload_State(state.SelectedFile, state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, FormState_get_empty(), state.LinkedEntityId), Cmd_none()];
        default:
            return [new FileDialog_Upload_State(msg.fields[0], state.UploadType, state.SuccessCallback, state.OnClose, state.Name, state.Description, state.IsVisibleForUserRole, state.FormState, state.LinkedEntityId), Cmd_none()];
    }
}

function FileDialog_Upload_DialogBody(props) {
    let elems_4;
    const t = useTranslation()[0];
    const patternInput_1 = useDrop({
        accept: nativeType.FILE,
        collect: (monitor) => {
            const isOver = monitor.isOver();
            return {
                canDrop: monitor.canDrop(),
                isOver: isOver,
            };
        },
        drop: (draggedFile) => {
            let testExpr, file;
            const matchValue = draggedFile.files;
            let matchResult, file_1;
            if (matchValue != null) {
                if ((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 1))) {
                    if ((file = item(0, matchValue), !props.FormState.IsLoading)) {
                        matchResult = 0;
                        file_1 = item(0, matchValue);
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    props.OnSelectFile(file_1);
                    break;
                }
                case 1: {
                    break;
                }
            }
        },
    });
    const dropData = patternInput_1[0];
    const formState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_4 = toList(delay(() => {
        let matchValue_1;
        return append((matchValue_1 = FormState__getValidation(props.FormState, t, "global"), (matchValue_1 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
            Label: matchValue_1,
        }))), delay(() => {
            let elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-col"), delay(() => append(singleton("justify-center"), delay(() => append(singleton("items-center"), delay(() => append(singleton("mt-4"), delay(() => append(singleton("mb-4"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("border-dashed"), delay(() => append(singleton("border-primary"), delay(() => ((dropData.canDrop && dropData.isOver) ? singleton("bg-background") : empty()))))))))))))))))))))))))], ["ref", patternInput_1[1]], (elems_2 = toList(delay(() => {
                let elems, Label;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "mb-4"])], (elems = [createElement(TextButton, (Label = t("file_upload.select_file"), {
                    ComponentState: formState,
                    Icon: Upload_File(),
                    Label: Label,
                    OnClick: () => {
                        const element = document.getElementById("file-upload");
                        element.click();
                    },
                    TestId: "open-file-explorer-test-id",
                    Variant: "blueButton",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                    let elems_1;
                    const matchValue_2 = props.SelectedFile;
                    if (matchValue_2 != null) {
                        const selectedFile = matchValue_2;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "justify-center", "items-center", "mx-4", "mb-4"])], (elems_1 = [createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: selectedFile.name,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                    }
                    else {
                        return empty();
                    }
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-center"])], (elems_3 = [reactElement("input", {
                    id: "file-upload",
                    className: join(" ", ["hidden"]),
                    type: "file",
                    disabled: props.FormState.IsLoading,
                    onChange: (ev) => {
                        const files = ev.target.files;
                        if (!(files == null) && (files.length > 0)) {
                            props.OnSelectFile(files.item(0));
                        }
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(singleton(createElement(Input, {
                    ComponentState: formState,
                    Label: t("general.name"),
                    OnChange: (arg) => {
                        props.Dispatch(new FileDialog_Upload_Msg(2, [arg]));
                    },
                    TestId: "document-name-input",
                    Value: props.Name,
                })), delay(() => append(singleton(createElement(Input, {
                    ComponentState: formState,
                    Label: t("general.description"),
                    OnChange: (arg_1) => {
                        props.Dispatch(new FileDialog_Upload_Msg(3, [arg_1]));
                    },
                    TestId: "document-description-input",
                    Value: props.Description,
                })), delay(() => append(singleton(Checkbox({
                    ComponentState: formState,
                    IsChecked: props.VisibleForUserRole,
                    Label: t("tool.document_visible_for_user_role"),
                    OnCheck: (_arg_1) => {
                        props.Dispatch(new FileDialog_Upload_Msg(1, []));
                    },
                    TestId: "document-visible-for-user-checkbox",
                })), delay(() => singleton(createElement(InformationAlert, {
                    Label: t("tool.document_visible_for_user_role_upload_info"),
                }))))))))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function FileDialog_Upload_FileUploadDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => FileDialog_Upload_init(props.UploadType, props.LinkedEntityId, props.SuccessCallback, props.OnClose), FileDialog_Upload_update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("general.upload_file"), {
        Body: singleton_1(createElement(FileDialog_Upload_DialogBody, {
            Description: state_1.Description,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            Name: state_1.Name,
            OnSelectFile: (value) => {
                dispatch(new FileDialog_Upload_Msg(0, [value]));
            },
            SelectedFile: unwrap(state_1.SelectedFile),
            VisibleForUserRole: state_1.IsVisibleForUserRole,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-document-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: (state_1.FormState.IsLoading ? true : (state_1.SelectedFile == null)) ? "disabled" : "enabled",
            Label: t("general.upload"),
            OnClick: () => {
                dispatch(new FileDialog_Upload_Msg(4, []));
            },
            TestId: "save-document-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

class FileDialog_Edit_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetIsVisibleForUserRole", "SetName", "SetDescription", "UpdateDocument", "DocumentUpdated", "FetchError"];
    }
}

function FileDialog_Edit_Msg_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Edit.Msg", [], FileDialog_Edit_Msg, () => [[], [["Item", string_type]], [["Item", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function FileDialog_Edit_updateToolDocumentCmd(toolId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/tools/", toolId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new FileDialog_Edit_Msg(4, [Item])), (Item_1) => (new FileDialog_Edit_Msg(5, [Item_1])));
}

function FileDialog_Edit_updateToolWithQuantityDocumentCmd(toolId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/tools-with-quantity/", toolId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new FileDialog_Edit_Msg(4, [Item])), (Item_1) => (new FileDialog_Edit_Msg(5, [Item_1])));
}

function FileDialog_Edit_updateConsumableDocumentCmd(consumableId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/consumables/", consumableId.fields[0], "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new FileDialog_Edit_Msg(4, [Item])), (Item_1) => (new FileDialog_Edit_Msg(5, [Item_1])));
}

function FileDialog_Edit_updateSetDocumentCmd(setId, documentId, dto) {
    return Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_3, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), [concat("/api/sets/", SetId__get_unwrap(setId), "/files/", ...DocumentId__get_unwrap(documentId)), toString_1(0, Auto_generateBoxedEncoder_437914C6(UpdateDocumentDto_$reflection(), undefined, undefined, undefined)(dto))], (Item) => (new FileDialog_Edit_Msg(4, [Item])), (Item_1) => (new FileDialog_Edit_Msg(5, [Item_1])));
}

class FileDialog_Edit_State extends Record {
    constructor(FormState, Document$, UploadType, SuccessCallback, OnClose, Dto) {
        super();
        this.FormState = FormState;
        this.Document = Document$;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Dto = Dto;
    }
}

function FileDialog_Edit_State_$reflection() {
    return record_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Edit.State", [], FileDialog_Edit_State, () => [["FormState", FormState_$reflection()], ["Document", DocumentDetail_$reflection()], ["UploadType", FileDialog_LinkedDocumentToolType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Dto", UpdateDocumentDto_$reflection()]]);
}

function FileDialog_Edit_init(uploadType, document$, successCallback, onClose) {
    return [new FileDialog_Edit_State(FormState_get_empty(), document$, uploadType, successCallback, onClose, new UpdateDocumentDto(document$.Name, document$.Description, document$.IsVisibleForUserRole)), Cmd_none()];
}

function FileDialog_Edit_update(msg, state) {
    let bind$0040, bind$0040_1, bind$0040_2;
    switch (msg.tag) {
        case 1:
            return [new FileDialog_Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040 = state.Dto, new UpdateDocumentDto(msg.fields[0], bind$0040.Description, bind$0040.IsVisibleForUserRole))), Cmd_none()];
        case 2:
            return [new FileDialog_Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040_1 = state.Dto, new UpdateDocumentDto(bind$0040_1.Name, msg.fields[0], bind$0040_1.IsVisibleForUserRole))), Cmd_none()];
        case 0:
            return [new FileDialog_Edit_State(state.FormState, state.Document, state.UploadType, state.SuccessCallback, state.OnClose, (bind$0040_2 = state.Dto, new UpdateDocumentDto(bind$0040_2.Name, bind$0040_2.Description, !state.Dto.IsVisibleForUserRole))), Cmd_none()];
        case 4:
            return [new FileDialog_Edit_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                state.SuccessCallback();
            }), Cmd_ofEffect((_arg_1) => {
                state.OnClose();
            }), Cmd_successToast("tool.dialog_document_edit_success")]))];
        case 5:
            return [new FileDialog_Edit_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
        default: {
            let cmd;
            const matchValue = state.UploadType;
            cmd = ((matchValue.tag === 2) ? FileDialog_Edit_updateToolWithQuantityDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : ((matchValue.tag === 1) ? FileDialog_Edit_updateConsumableDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : ((matchValue.tag === 3) ? FileDialog_Edit_updateSetDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto) : FileDialog_Edit_updateToolDocumentCmd(matchValue.fields[0], state.Document.Id, state.Dto))));
            return [new FileDialog_Edit_State(FormState__startLoading(state.FormState), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), cmd];
        }
    }
}

function FileDialog_Edit_DialogBody(props) {
    let elems;
    const t = useTranslation()[0];
    const formState = props.FormState.IsLoading ? "disabled" : (props.IsUserAuthorized ? "enabled" : "disabled");
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems = [createElement(Input, {
        ComponentState: formState,
        Label: t("general.name"),
        OnChange: (arg) => {
            props.Dispatch(new FileDialog_Edit_Msg(1, [arg]));
        },
        TestId: "document-name-input",
        Value: props.Name,
    }), createElement(Input, {
        ComponentState: formState,
        Label: t("general.description"),
        OnChange: (arg_1) => {
            props.Dispatch(new FileDialog_Edit_Msg(2, [arg_1]));
        },
        TestId: "document-description-input",
        Value: props.Description,
    }), Checkbox({
        ComponentState: formState,
        IsChecked: props.VisibleForUserRole,
        Label: t("tool.document_visible_for_user_role"),
        OnCheck: (_arg) => {
            props.Dispatch(new FileDialog_Edit_Msg(0, []));
        },
        TestId: "document-visible-for-user-checkbox",
    }), createElement(InformationAlert, {
        Label: t("tool.document_visible_for_user_role_upload_info"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function FileDialog_Edit_FileEditDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => FileDialog_Edit_init(props.UploadType, props.Document, props.SuccessCallback, props.OnClose), FileDialog_Edit_update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    return createElement(Dialog, (Title = t("tool.dialog_document_edit_button"), {
        Body: singleton_1(createElement(FileDialog_Edit_DialogBody, {
            Description: state_1.Dto.Description,
            Dispatch: dispatch,
            FormState: state_1.FormState,
            IsUserAuthorized: props.IsUserAuthorized,
            Name: state_1.Dto.Name,
            VisibleForUserRole: state_1.Dto.IsVisibleForUserRole,
        })),
        Controls: toList(delay(() => append(singleton(createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-document-dialog-test-id",
            Variant: "blueButton",
        })), delay(() => (props.IsUserAuthorized ? singleton(createElement(TextButton, {
            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new FileDialog_Edit_Msg(3, []));
            },
            TestId: "save-document-dialog-test-id",
            Variant: "blueButton",
        })) : empty()))))),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

class FileDialog_Delete_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteDocument", "DocumentDeleted", "FetchError"];
    }
}

function FileDialog_Delete_Msg_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Delete.Msg", [], FileDialog_Delete_Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

function FileDialog_Delete_deleteToolDocumentCmd(toolId, documentId) {
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/tools/", unwrapToolId(toolId), "/files/", ...unwrapDocumentId(documentId)), (Item) => (new FileDialog_Delete_Msg(1, [Item])), (Item_1) => (new FileDialog_Delete_Msg(2, [Item_1])));
}

function FileDialog_Delete_deleteConsumableDocumentCmd(consumableId, documentId) {
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/consumables/", unwrapConsumableId(consumableId), "/files/", ...unwrapDocumentId(documentId)), (Item) => (new FileDialog_Delete_Msg(1, [Item])), (Item_1) => (new FileDialog_Delete_Msg(2, [Item_1])));
}

function FileDialog_Delete_deleteSetDocumentCmd(setId, documentId) {
    const docId = unwrapDocumentId(documentId);
    return Cmd_OfPromise_either((url_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_3;
        return ((url_3 = addPrefix(url_1), (refreshOn) => fetchWithDecoder(url_3, singleton_1(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
        }, refreshOn)))(true);
    })), concat("/api/sets/", SetId__get_unwrap(setId), "/files/", ...docId), (Item) => (new FileDialog_Delete_Msg(1, [Item])), (Item_1) => (new FileDialog_Delete_Msg(2, [Item_1])));
}

class FileDialog_Delete_State extends Record {
    constructor(FormState, Document$, UploadType, SuccessCallback, OnClose, Dto) {
        super();
        this.FormState = FormState;
        this.Document = Document$;
        this.UploadType = UploadType;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Dto = Dto;
    }
}

function FileDialog_Delete_State_$reflection() {
    return record_type("Widgets.Modals.LinkedDocumentModal.FileDialog.Delete.State", [], FileDialog_Delete_State, () => [["FormState", FormState_$reflection()], ["Document", DocumentDetail_$reflection()], ["UploadType", FileDialog_LinkedDocumentToolType_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Dto", UpdateDocumentDto_$reflection()]]);
}

function FileDialog_Delete_init(uploadType, document$, successCallback, onClose) {
    return [new FileDialog_Delete_State(FormState_get_empty(), document$, uploadType, successCallback, onClose, new UpdateDocumentDto(document$.Name, document$.Description, document$.IsVisibleForUserRole)), Cmd_none()];
}

function FileDialog_Delete_update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new FileDialog_Delete_State(FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
            }
            else {
                return [new FileDialog_Delete_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                }), Cmd_successToast("tool.dialog_document_delete_success")]))];
            }
        }
        case 2:
            return [new FileDialog_Delete_State(FormState_get_empty(), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), Cmd_none()];
        default: {
            let cmd;
            const matchValue = state.UploadType;
            cmd = ((matchValue.tag === 2) ? FileDialog_Delete_deleteToolDocumentCmd(matchValue.fields[0], state.Document.Id) : ((matchValue.tag === 1) ? FileDialog_Delete_deleteConsumableDocumentCmd(matchValue.fields[0], state.Document.Id) : ((matchValue.tag === 3) ? FileDialog_Delete_deleteSetDocumentCmd(matchValue.fields[0], state.Document.Id) : FileDialog_Delete_deleteToolDocumentCmd(matchValue.fields[0], state.Document.Id))));
            return [new FileDialog_Delete_State(FormState__startLoading(state.FormState), state.Document, state.UploadType, state.SuccessCallback, state.OnClose, state.Dto), cmd];
        }
    }
}

export function FileDialog_Delete_FileDeleteDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => FileDialog_Delete_init(props.UploadType, props.Document, props.SuccessCallback, props.OnClose), FileDialog_Delete_update, (_arg_1, _arg_1_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    return createElement(ConfirmationDialog, (Title = t("general.delete"), {
        Description: t("tool.dialog_document_delete_msg"),
        FormState: state_1.FormState,
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        OnConfirm: state_1.FormState.IsLoading ? (() => {
        }) : (() => {
            patternInput_1[1](new FileDialog_Delete_Msg(0, []));
        }),
        Title: Title,
    }));
}

export class DocumentTable_TableDocument extends Record {
    constructor(Id, Description, UploadDate, Name, FileName, VisibleForUserRole, Url) {
        super();
        this.Id = Id;
        this.Description = Description;
        this.UploadDate = UploadDate;
        this.Name = Name;
        this.FileName = FileName;
        this.VisibleForUserRole = VisibleForUserRole;
        this.Url = Url;
    }
}

export function DocumentTable_TableDocument_$reflection() {
    return record_type("Widgets.Modals.LinkedDocumentModal.DocumentTable.TableDocument", [], DocumentTable_TableDocument, () => [["Id", DocumentId_$reflection()], ["Description", string_type], ["UploadDate", class_type("System.DateTime")], ["Name", string_type], ["FileName", string_type], ["VisibleForUserRole", bool_type], ["Url", string_type]]);
}

function DocumentTable_isImage(fileName) {
    if ((fileName.toLocaleLowerCase().endsWith(".jpg") ? true : fileName.toLocaleLowerCase().endsWith(".jpeg")) ? true : fileName.toLocaleLowerCase().endsWith(".png")) {
        return true;
    }
    else {
        return fileName.toLocaleLowerCase().endsWith(".gif");
    }
}

function DocumentTable_isPdf(fileName) {
    return fileName.toLocaleLowerCase().endsWith(".pdf");
}

export function DocumentTable_ImageGallery(props) {
    return ImageViewer({
        Images: singleton_1({
            Src: props.ImageUrl,
        }),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
    });
}

export function DocumentTable_DocumentTable(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canCreateDocuments = Permissions_has(permissions, new Permission(26, []));
    const canUpdateDocuments = Permissions_has(permissions, new Permission(27, []));
    const canDeleteDocuments = Permissions_has(permissions, new Permission(28, []));
    const patternInput_1 = reactApi.useState(false);
    const setIsUploadDialogOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setIsEditDialogOpen = patternInput_2[1];
    const isEditDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsDeleteDialogOpen = patternInput_3[1];
    const isDeleteDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const selectedImage = patternInput_4[0];
    const rows = map((d) => (new DocumentTable_TableDocument(d.Id, d.Description, d.UploadDate, d.Name, d.FileName, d.IsVisibleForUserRole, d.Url)), props.Documents);
    const xs_2 = toList(delay(() => append(singleton(DocumentTable_ImageGallery({
        ImageUrl: defaultArg(selectedImage, ""),
        IsOpen: selectedImage != null,
        OnClose: () => {
            patternInput_4[1](undefined);
        },
    })), delay(() => append(singleton(createElement(FileDialog_Upload_FileUploadDialog, {
        IsOpen: patternInput_1[0],
        LinkedEntityId: props.LinkedEntityId,
        OnClose: () => {
            setIsUploadDialogOpen(false);
        },
        SuccessCallback: props.UploadSuccessCallback,
        UploadType: props.UploadType,
    })), delay(() => {
        let matchValue;
        return append((matchValue = isEditDialogOpen, (matchValue == null) ? (empty()) : singleton(createElement(FileDialog_Edit_FileEditDialog, {
            Document: matchValue,
            IsOpen: isEditDialogOpen != null,
            IsUserAuthorized: canUpdateDocuments,
            OnClose: () => {
                setIsEditDialogOpen(undefined);
            },
            SuccessCallback: props.UploadSuccessCallback,
            UploadType: props.UploadType,
        }))), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = isDeleteDialogOpen, (matchValue_1 == null) ? (empty()) : singleton(createElement(FileDialog_Delete_FileDeleteDialog, {
                Document: matchValue_1,
                IsOpen: isDeleteDialogOpen != null,
                IsUserAuthorized: canDeleteDocuments,
                OnClose: () => {
                    setIsDeleteDialogOpen(undefined);
                },
                SuccessCallback: props.UploadSuccessCallback,
                UploadType: props.UploadType,
            }))), delay(() => {
                let TableRows, Options;
                return singleton(createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["uploadDate", "asc"],
                    Fullscreen: false,
                    GlobalSearch: true,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("image", "", t("general.preview"), (row) => {
                        let elems, elems_1;
                        return DocumentTable_isPdf(row.FileName) ? (new CellContent(2, [reactElement("div", createObj(ofArray([["onClick", (e) => {
                            e.preventDefault();
                            window.open(row.Url, "_blank", "noreferrer");
                        }], ["className", join(" ", ["flex", "justify-center", "h-5", "cursor-pointer"])], (elems = [Convert_PDF_2()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])) : (DocumentTable_isImage(row.FileName) ? (new CellContent(6, [row.Url])) : (new CellContent(2, [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "h-5"])], (elems_1 = [New_File()], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))])));
                    }, "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("uploadDate", "", t("tool.uploaded_on"), (row_1) => (new CellContent(9, [row_1.UploadDate])), "none", "dateTime")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("description", "", t("general.description"), (row_3) => (new CellContent(0, [row_3.Description])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("fileName", "", t("general.file_name"), (row_4) => (new CellContent(0, [row_4.FileName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("visibleForUserRole", "", t("tool.document_visible_for_user_role"), (row_5) => (row_5.VisibleForUserRole ? (new CellContent(0, [t("general.yes")])) : (new CellContent(0, [t("general.no")]))), "select", "text")), delay(() => props.AdditionalColumns)))))))))))))),
                    Controls: toList(delay(() => append(canCreateDocuments ? singleton(new TableControl$1(t("general.upload_file"), Upload_File(), (_arg_4) => {
                        setIsUploadDialogOpen(true);
                    }, false, false, "linked-document-upload-file")) : empty(), delay(() => append(singleton(new TableControl$1(t("general.download_file"), Download_File(), (rows_1) => {
                        if (length(rows_1) === 1) {
                            props.OnDownloadFile([item_1(0, rows_1).Id, item_1(0, rows_1).FileName]);
                        }
                    }, true, false, "linked-document-download-file")), delay(() => append(canUpdateDocuments ? singleton(new TableControl$1(t("general.edit"), Pencil(), (row_6) => {
                        const matchValue_2 = tryHead(row_6);
                        if (matchValue_2 == null) {
                        }
                        else {
                            const row_7 = matchValue_2;
                            setIsEditDialogOpen(tryFind((doc) => equals(doc.Id, row_7.Id), props.Documents));
                        }
                    }, true, false, "linked-document-edit")) : empty(), delay(() => (canDeleteDocuments ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (row_8) => {
                        const matchValue_3 = tryHead(row_8);
                        if (matchValue_3 == null) {
                        }
                        else {
                            const row_9 = matchValue_3;
                            setIsDeleteDialogOpen(tryFind((doc_1) => equals(doc_1.Id, row_9.Id), props.Documents));
                        }
                    }, true, false, "linked-document-delete")) : empty()))))))))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                }))));
            }));
        }));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

class Modal_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FetchDocuments", "DocumentsFetched", "DownloadFile", "DocumentDownloaded", "BlobReceived", "FetchError"];
    }
}

function Modal_Msg_$reflection() {
    return union_type("Widgets.Modals.LinkedDocumentModal.Modal.Msg", [], Modal_Msg, () => [[], [["Item", list_type(DocumentDetail_$reflection())]], [["Item1", DocumentId_$reflection()], ["fileName", string_type]], [["Item1", class_type("Fetch.Types.Response")], ["Item2", string_type]], [["Item1", class_type("Browser.Types.Blob", undefined)], ["Item2", string_type]], [["Item", class_type("System.Exception")]]]);
}

class Modal_State extends Record {
    constructor(Documents, LinkedEntityId, UploadType) {
        super();
        this.Documents = Documents;
        this.LinkedEntityId = LinkedEntityId;
        this.UploadType = UploadType;
    }
}

function Modal_State_$reflection() {
    return record_type("Widgets.Modals.LinkedDocumentModal.Modal.State", [], Modal_State, () => [["Documents", RequestedValue$1_$reflection(list_type(DocumentDetail_$reflection()))], ["LinkedEntityId", FileDialog_LinkedEntityId_$reflection()], ["UploadType", FileDialog_LinkedDocumentToolType_$reflection()]]);
}

function Modal_init(onClose, uploadType, linkedEntityId, documents) {
    return [new Modal_State(new RequestedValue$1(1, [documents]), linkedEntityId, uploadType), Cmd_none()];
}

function Modal_update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new Modal_State(new RequestedValue$1(1, [filter((doc) => {
                const matchValue_1 = state.LinkedEntityId;
                if (matchValue_1.tag === 1) {
                    const matchValue_3 = doc.LinkedInspectionResultInformation;
                    if (matchValue_3 == null) {
                        return false;
                    }
                    else {
                        return matchValue_3.InspectionResultId === matchValue_1.fields[0];
                    }
                }
                else {
                    const matchValue_2 = doc.LinkedReminderInformation;
                    if (matchValue_2 == null) {
                        return false;
                    }
                    else {
                        return matchValue_2.ReminderId === matchValue_1.fields[0];
                    }
                }
            }, msg.fields[0])]), state.LinkedEntityId, state.UploadType), Cmd_none()];
        case 2: {
            const fileName = msg.fields[1];
            const documentId = msg.fields[0];
            const matchValue_4 = state.UploadType;
            switch (matchValue_4.tag) {
                case 1:
                    return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), Cmd_downloadFileCmd(matchValue_4.fields[0], documentId, fileName, (tupledArg_1) => (new Modal_Msg(3, [tupledArg_1[0], tupledArg_1[1]])), (Item_13) => (new Modal_Msg(5, [Item_13])))]))];
                case 2:
                    return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), Cmd_downloadFileCmd_1(matchValue_4.fields[0], documentId, fileName, (tupledArg_2) => (new Modal_Msg(3, [tupledArg_2[0], tupledArg_2[1]])), (Item_16) => (new Modal_Msg(5, [Item_16])))]))];
                case 3:
                    return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), downloadFileCmd(matchValue_4.fields[0], documentId, fileName, (tupledArg_3) => (new Modal_Msg(3, [tupledArg_3[0], tupledArg_3[1]])), (Item_19) => (new Modal_Msg(5, [Item_19])))]))];
                default:
                    return [state, Cmd_batch(ofArray([Cmd_successToast("general.download_started"), Cmd_downloadFileCmd_1(matchValue_4.fields[0], documentId, fileName, (tupledArg) => (new Modal_Msg(3, [tupledArg[0], tupledArg[1]])), (Item_10) => (new Modal_Msg(5, [Item_10])))]))];
            }
        }
        case 3:
            return [state, getBlob(msg.fields[0], msg.fields[1], (tupledArg_4) => (new Modal_Msg(4, [tupledArg_4[0], tupledArg_4[1]])), (Item_22) => (new Modal_Msg(5, [Item_22])))];
        case 4: {
            onBlobReceived(msg.fields[0], msg.fields[1]);
            return [state, Cmd_none()];
        }
        case 5:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.UploadType;
            switch (matchValue.tag) {
                case 1:
                    return [state, Cmd_OfPromise_either_1((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_5;
                        return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
                            const pr_1 = response_2.arrayBuffer();
                            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(DocumentDetail_$reflection())));
                        }, refreshOn_1)))(true).then((_arg_1) => {
                            const result_3 = _arg_1;
                            return (result_3.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_3.fields[0]);
                            })())) : (Promise.resolve(result_3.fields[0]));
                        });
                    })), concat("/api/consumables/", unwrapConsumableId_1(matchValue.fields[0]), ..."/documents"), (Item_2) => (new Modal_Msg(1, [Item_2])), (Item_3) => (new Modal_Msg(5, [Item_3])))];
                case 2:
                    return [state, Cmd_OfPromise_either_1((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_8;
                        return ((url_8 = addPrefix(url_6), (refreshOn_2) => fetchWithDecoder(url_8, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_4) => {
                            const pr_2 = response_4.arrayBuffer();
                            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(DocumentDetail_$reflection())));
                        }, refreshOn_2)))(true).then((_arg_2) => {
                            const result_5 = _arg_2;
                            return (result_5.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_5.fields[0]);
                            })())) : (Promise.resolve(result_5.fields[0]));
                        });
                    })), concat("/api/tools/", unwrapToolId_1(matchValue.fields[0]), ..."/documents"), (Item_4) => (new Modal_Msg(1, [Item_4])), (Item_5) => (new Modal_Msg(5, [Item_5])))];
                case 3:
                    return [state, Cmd_OfPromise_either_1((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_11;
                        return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_6) => {
                            const pr_3 = response_6.arrayBuffer();
                            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), list_type(DocumentDetail_$reflection())));
                        }, refreshOn_3)))(true).then((_arg_3) => {
                            const result_7 = _arg_3;
                            return (result_7.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_7.fields[0]);
                            })())) : (Promise.resolve(result_7.fields[0]));
                        });
                    })), concat("/api/sets/", SetId__get_unwrap_1(matchValue.fields[0]), ..."/documents"), (Item_6) => (new Modal_Msg(1, [Item_6])), (Item_7) => (new Modal_Msg(5, [Item_7])))];
                default:
                    return [state, Cmd_OfPromise_either_1((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        let url_2;
                        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                            const pr = response.arrayBuffer();
                            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DocumentDetail_$reflection())));
                        }, refreshOn)))(true).then((_arg) => {
                            const result_1 = _arg;
                            return (result_1.tag === 1) ? (Promise.resolve((() => {
                                throw new ValidationOnGetRequest(result_1.fields[0]);
                            })())) : (Promise.resolve(result_1.fields[0]));
                        });
                    })), concat("/api/tools/", unwrapToolId_1(matchValue.fields[0]), ..."/documents"), (Item) => (new Modal_Msg(1, [Item])), (Item_1) => (new Modal_Msg(5, [Item_1])))];
            }
        }
    }
}

function Modal_Content(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(ChangelogTable, {
        Changelogs: props.Changelogs,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function Modal_LinkedDocumentsModalSheet(props) {
    let elems, matchValue;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => Modal_init(props.OnClose, props.UploadType, props.LinkedEntityId, props.Documents), Modal_update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const dispatch = patternInput[1];
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = patternInput[0].Documents, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(DocumentTable_DocumentTable, {
            AdditionalColumns: empty_1(),
            Documents: matchValue.fields[0],
            LinkedEntityId: props.LinkedEntityId,
            OnDownloadFile: (tupledArg) => {
                dispatch(new Modal_Msg(2, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                dispatch(new Modal_Msg(0, []));
            },
            UploadType: props.UploadType,
            UserData: props.UserData,
        })),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function Modal_OpenLinkedDocumentModalButtonModalSheet(props) {
    let elems;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(undefined);
    const setIsChangelogModalOpen = patternInput_1[1];
    const isChangelogModalOpen = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => append((isChangelogModalOpen == null) ? (empty()) : singleton(createElement(Modal_LinkedDocumentsModalSheet, {
        Documents: props.Documents,
        IsOpen: isChangelogModalOpen != null,
        LinkedEntityId: props.LinkedEntityId,
        OnClose: () => {
            props.OnClose();
            setIsChangelogModalOpen(undefined);
        },
        UploadType: props.UploadType,
        UserData: props.UserData,
    })), delay(() => singleton(createElement(TextButton, {
        ComponentState: "enabled",
        Label: patternInput[0]("general.display"),
        OnClick: () => {
            setIsChangelogModalOpen(props.UploadType);
        },
        TestId: "open-linked-document-modal-icon-button",
        Variant: "blueButton",
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

